import { takeLatest, call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import { loginReset } from "../action/loginAction";
import { preLoginReset } from "../action/preLoginAction";
import { sessionInvalidate } from "../action/sessionAction";
import * as _api from "../../api";
import * as types from "../types";

function* asyncLogoutSaga() {
  try {
    yield call(_api.logoutUser);
    yield put(loginReset());
    yield put(preLoginReset());
    yield put(sessionInvalidate());
  } catch (e) {
    const msg = e.response?.data?.message || e.message;
    Swal.fire({
      icon: 'error',
      text: msg || 'Logout failed, please try again',
      confirmButtonColor: '#008d37',
      timer: 15000,
    });
  }
}
export default function* logoutSaga() {
  yield takeLatest(types.LOGOUT_REQUEST, asyncLogoutSaga);
}
